<div class="consent-container">
  <rs-web-whitelabel-image
    [whitelabelImage]="WhitelabelImage.POINTING"
    [altTag]="WhitelabelImageAltTag.POINTING | translate"
    [onSurface]="true"
    [whitelabelImageType]="WhitelabelImageType.SVG"
  ></rs-web-whitelabel-image>
  <h1>{{ 'consent.terms_and_conditions_title' | translate }}</h1>

  <p>
    {{ 'consent.terms_and_conditions_start' | translate }}
    <a
      [routerLink]="footerItemAgb.unauthenticatedBase"
      [queryParams]="{ link: footerItemAgb.link }"
    >
      {{ 'consent.terms_and_conditions_link' | translate }}
    </a>
    {{ 'consent.terms_and_conditions_end' | translate }}
  </p>

  <div class="d-flex flex-column gap-2">
    <button
      im-button
      class="primary"
      (click)="acceptConsent.emit({ legalTextId: legalTexts().agbId, consentGiven: true })"
      [disabled]="isLoading()"
    >
      {{ 'agree_l' | translate }}
    </button>
    <button im-button class="inverted" (click)="declineConsent.emit()" [disabled]="isLoading()">
      {{ 'decline_l' | translate }}
    </button>
  </div>
</div>
